"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "Do I need to be home during the cleaning?",
  answer: "We understand you’re busy. You do not need to be home, provided we have a secure way to enter, such as a key or door code. Many of our clients prefer to be out while we work our magic, returning to a freshly detailed space."
}, {
  question: "What is the difference between a Standard and Deep Clean?",
  answer: "A Standard Clean is designed to maintain your home’s cleanliness with regular dusting, vacuuming, and surface wiping. A Deep Clean is much more intensive, tackling built-up grime, baseboards, ceiling fans, and detailed areas—perfect for first-time visits or seasonal refreshes."
}, {
  question: "Do you provide your own cleaning supplies?",
  answer: "Yes. We bring our own professional-grade equipment and premium supplies to ensure a consistent, high-quality result every time. You don't need to worry about stocking anything."
}, {
  question: "How do I book an appointment?",
  answer: "You can book directly through our responsive online system for maximum convenience. However, if you have specific questions or a unique property, we welcome you to call or text us directly for personalized scheduling."
}, {
  question: "Are you insured and bonded?",
  answer: "Absolutely. Pure Detail Cleaning is fully insured and bonded. We take great pride in our professionalism and accountability, ensuring your peace of mind and protection."
}, {
  question: "What areas of Central Texas do you serve?",
  answer: "We proudly serve homeowners, realtors, and businesses across Central Texas. Please contact us to confirm if your specific neighborhood or location is within our current service range."
}];
export default function PureAnswersForPureDetail() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="pure-answers-for-pure-detail" ref={ref} className={cn("bg-background text-foreground py-20 px-6 md:px-12 lg:px-24 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight">
            Questions Clients Ask Most
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Clear answers for a clear mind. Here is everything you need to know
            about our disciplined approach to cleaning.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/40 last:border-0 px-2" data-index={i}>
              <AccordionTrigger className="text-foreground font-bold text-lg hover:text-primary transition-colors hover:no-underline py-6 text-left rounded-none">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-primary/80 font-medium text-base leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}